import styled from 'styled-components'
import Link from 'next/link'
import MedalistsTitle from '../MedalistsTitle'
import MedalistPhase2Card from '../../MedallistPhase2Card'
import MedalistPhase2Category from '../../MedalistPhase2Category'
import useMedalistsPhase2 from '../../../../hooks/useMedalistsPhase2'

const ModuleMedallistsPhase2 = (props: any) => {
  const { labelsData, groupByCategory } = useMedalistsPhase2()

  return (
    <StyledComponent className='px-0 snap-section-start'>
      <div className='theme-black snap-section-start hide-floating-logos relative top-[10px] pt-[85px] md:pt-[185px] lg:pt-[200px]' />
      {/* Make a 12 column grid with Tailwind */}
      <div className='wrapper'>
        <MedalistsTitle title={props.medallistBlockHeading} brief={props.medallistBlockHeadingBrief} />
        <div className='px-[12px] lg:px-[18px]'>
          <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
            <MedalistPhase2Category text={labelsData?.MedalistCategories?.IconArtist || '{IconArtist}'} />
            <div className='grid grid-cols-3 lg:grid-cols-6 gap-2 md:gap-[18px] lg:gap-4'>
              {groupByCategory?.IconArtist?.map((item: any) => (
                <Link key={item.id} href={`/medalist/${item.id}`}>
                  <MedalistPhase2Card
                    key={item.id}
                    name={item.attributes.name}
                    $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                  />
                </Link>
              ))}
            </div>
          </div>
          <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
            <MedalistPhase2Category text={labelsData?.MedalistCategories?.EstablishedArtist || '{EstablishedArtist}'} />
            <div className='grid grid-cols-3 lg:grid-cols-6 gap-2 md:gap-[18px] lg:gap-4'>
              {groupByCategory?.EstablishedArtist?.map((item: any) => (
                <Link key={item.id} href={`/medalist/${item.id}`}>
                  <MedalistPhase2Card
                    key={item.id}
                    name={item.attributes.name}
                    $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                  />
                </Link>
              ))}
            </div>
          </div>
          <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
            <MedalistPhase2Category text={labelsData?.MedalistCategories?.EmergingArtist || '{EmergingArtist}'} />
            <div className='grid grid-cols-3 lg:grid-cols-6 gap-2 md:gap-[18px] lg:gap-4'>
              {groupByCategory?.EmergingArtist?.map((item: any) => (
                <Link key={item.id} href={`/medalist/${item.id}`}>
                  <MedalistPhase2Card
                    key={item.id}
                    name={item.attributes.name}
                    $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                  />
                </Link>
              ))}
            </div>
          </div>
          <div className='group-section grid grid-col-1 lg:grid-cols-2 gap-2 lg:gap-4'>
            <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
              <MedalistPhase2Category text={labelsData?.MedalistCategories?.CrossDisciplinaryCreator || '{CrossDisciplinaryCreator}'} />
              <div className='grid grid-cols-3 lg:grid-cols-3 gap-2 md:gap-[18px] lg:gap-[16px]'>
                {groupByCategory?.CrossDisciplinaryCreator?.map((item: any) => (
                  <Link key={item.id} href={`/medalist/${item.id}`}>
                    <MedalistPhase2Card
                      key={item.id}
                      name={item.attributes.name}
                      $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                    />
                  </Link>
                ))}
              </div>
            </div>
            <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
              <MedalistPhase2Category text={labelsData?.MedalistCategories?.Patrons || '{Patrons}'} />
              <div className='grid grid-cols-3 lg:grid-cols-3 gap-2 md:gap-[18px] lg:gap-[16px]'>
                {groupByCategory?.Patrons?.map((item: any) => (
                  <Link key={item.id} href={`/medalist/${item.id}`}>
                    <MedalistPhase2Card
                      key={item.id}
                      name={item.attributes.name}
                      $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                    />
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <div className='group-section grid grid-col-1 lg:grid-cols-2 gap-2 lg:gap-4'>
            <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
              <MedalistPhase2Category text={labelsData?.MedalistCategories?.MuseumsAndInstitutions || '{MuseumsAndInstitutions}'} />
              <div className='grid grid-cols-3 lg:grid-cols-3 gap-2 md:gap-[18px] lg:gap-[16px]'>
                {groupByCategory?.MuseumsAndInstitutions?.map((item: any) => (
                  <Link key={item.id} href={`/medalist/${item.id}`}>
                    <MedalistPhase2Card
                      key={item.id}
                      name={item.attributes.name}
                      $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                    />
                  </Link>
                ))}
              </div>
            </div>
            <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
              <MedalistPhase2Category text={labelsData?.MedalistCategories?.Curator || '{Curator}'} />
              <div className='grid grid-cols-3 lg:grid-cols-3 gap-2 md:gap-[18px] lg:gap-[16px]'>
                {groupByCategory?.Curator?.map((item: any) => (
                  <Link key={item.id} href={`/medalist/${item.id}`}>
                    <MedalistPhase2Card
                      key={item.id}
                      name={item.attributes.name}
                      $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                    />
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <div className='group-section grid grid-col-1 lg:grid-cols-2 gap-2 lg:gap-4'>
            <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
              <MedalistPhase2Category text={labelsData?.MedalistCategories?.MediaAndStorytelling || '{MediaAndStorytelling}'} />
              <div className='grid grid-cols-3 lg:grid-cols-3 gap-2 md:gap-[18px] lg:gap-[16px]'>
                {groupByCategory?.MediaAndStorytelling?.map((item: any) => (
                  <Link key={item.id} href={`/medalist/${item.id}`}>
                    <MedalistPhase2Card
                      key={item.id}
                      name={item.attributes.name}
                      $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                    />
                  </Link>
                ))}
              </div>
            </div>
            <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
              <MedalistPhase2Category text={labelsData?.MedalistCategories?.Allies || '{Allies}'} />
              <div className='grid grid-cols-3 lg:grid-cols-3 gap-2 md:gap-[18px] lg:gap-[16px]'>
                {groupByCategory?.Allies?.map((item: any) => (
                  <Link key={item.id} href={`/medalist/${item.id}`}>
                    <MedalistPhase2Card
                      key={item.id}
                      name={item.attributes.name}
                      $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                    />
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledComponent>
  )
}

const StyledComponent = styled.div<any>`
  scroll-snap-align: start;
  > div.wrapper {
    justify-content: center;
    margin: 0 auto;
    align-items: center;
  }
`

export default ModuleMedallistsPhase2